import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import { SovosBox, SovosButtonsGroup, SovosDrawerHeader, SovosIconButton } from "mosaic-react";
import { Close } from "mosaic-react-icons";
import { useTheme } from "mosaic-react/styles";

export default function ModalHeaderCloseCustom(props) {
    const { i18n } = useGlobalValue();
    const theme = useTheme();
    const { pop, id: modalID, title, closeButtonAction } = props || {};
    return (
        <SovosBox sx={{ width: "100%" }}>
            <SovosDrawerHeader title={i18n`${title}`}>
                <SovosButtonsGroup align={"right"}>
                    <SovosIconButton
                        tooltipText={"Close"}
                        onClick={() => {
                            pop(modalID);
                            closeButtonAction && closeButtonAction();
                        }}
                        color={theme.palette.text.primary}
                        children={<Close />}
                    />
                </SovosButtonsGroup>
            </SovosDrawerHeader>
        </SovosBox>
    );
}
